<template>
    <section
        class="roadmap section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="roadmap-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content" />
                <c-timeline>
                    <c-timeline-item title="May 2012">
                        Started our logistics business.
                    </c-timeline-item>
                    <c-timeline-item title="May 2020">
                        Expanded into import logistics.
                    </c-timeline-item>
                    <c-timeline-item title="May 2022">
                        Moved into our own warehouse in Kewdale, next to the 77G container depots.
                    </c-timeline-item>
                    <c-timeline-item title="December 2024">
                        Granted a customs broker licence by the Australian Border Force.
                    </c-timeline-item>
                </c-timeline>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CTimeline from '@/components/elements/Timeline.vue'
import CTimelineItem from '@/components/elements/TimelineItem.vue'

export default {
  name: 'CRoadmap',
  components: {
    CSectionHeader,
    CTimeline,
    CTimelineItem
  },  
  mixins: [SectionProps],
  data() {
    return {
      sectionHeader: {
        title: 'Our Story 公司历程',
        paragraph:
          'Growing steadily since 2012'
      }
    }
  }  
}
</script>